export function isEmpty(str: string): boolean {
    const isEmptyOrDefault = (value: string | undefined | null): boolean =>
        !value;

    return isEmptyOrDefault(str);
}

export function toFixedFormat(num: number, decimals = 3) {
    const fixedNum = num.toFixed(decimals);
    if (!fixedNum.includes('.')) {
        return fixedNum;
    }
    let resultArr = fixedNum.split('');
    while (resultArr.lastIndexOf('0') === resultArr.length - 1) {
        resultArr.pop();
    }
    if (resultArr.lastIndexOf('.') === resultArr.length - 1) {
        resultArr.pop();
    }
    return +resultArr.join('');
}